export default __webpack_public_path__ + "static/media/Fb.069521c2.svg";